import { render } from "./ProfileStatus.vue?vue&type=template&id=bfad32f0&scoped=true"
import script from "./ProfileStatus.vue?vue&type=script&lang=js"
export * from "./ProfileStatus.vue?vue&type=script&lang=js"

import "./ProfileStatus.vue?vue&type=style&index=0&id=bfad32f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfad32f0"]])

export default __exports__